// extracted by mini-css-extract-plugin
module.exports = {"root":"NavBrand_root__xyLrp"};